<template>
  <div class="login-container">
    <div class="login">

      <div class="page-title-wrapper">
        <h1>Login to your account</h1>
      </div>

      <p>Login to pre-fill your details and add your order to your existing account</p>

      <div class="input-wrap">
        <label for="email">Email address</label>
        <div class="icon-inner-wrap">
          <input
            type="email"
            id="email-login"
            required>
        </div>
      </div>

      <div class="input-wrap">
        <label for="password">Password</label>
        <div class="icon-inner-wrap">
          <input
            type="password"
            id="password"
            required>
        </div>
      </div>

      <a>Forgotten your password?</a>

      <button class="default cta">Login</button>

      <a
        class="dismiss"
        @click="dismiss">Close</a>

    </div>
  </div>
</template>

<script>
export default {
  props: {
  },
  methods: {
    dismiss: function (event) {
      this.$emit('dismiss')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/library/login.vue